module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/4@2x_0fe293b294ca97e5c3fc0a6ebd293634.png";